// react
import React from "react";

// react-router-dom
import { useNavigate } from "react-router-dom";

// components
import DeviceCard from "../../components/Cards/dashboardCards/dashboardCardComponent";
import DeviceGraph from "../../components/graph/graphComponent";

// mui
import { Box, Grid } from "@mui/material";

// Dashboard-Component
const Dashboard = (props) => {
  const navigate = useNavigate();

  return (
    <>
      <Grid container sx={{ mt: { xs : '50px', sm : '30px'}, }}>
      <Grid
          item
          container
          sx = {{ alignItems : 'grid', justifyContent : 'center', }}
        >
          <p style={{ fontSize: "14px", fontWeight: "500" }}>
            Device Health Information
          </p>
        </Grid>
        <Grid
          item
          container
          sx={{
            display: "grid",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item sx={{ mb: { xs : '20px', md: "20px" } }}>
            <DeviceCard />
          </Grid>
          <Grid item>
            <DeviceGraph devEUI={props.devEUI} />
          </Grid>

          <Grid item sx={{ width: "300px", m: "10px 0px" }}>
            <Box sx={{ fontSize: "15px", fontWeight: "500px" , display : 'grid', justifyContent : 'center'}}>
              <p style={{ fontWeight: "bold", fontSize : '13px' }}>
                Please use fogwing IIoT Mobile App for securely viewing this
                device payloads.
              </p>
            </Box>
          </Grid>
          <Grid
            item
            sx={{ display: "grid", justifyContent: "center", mb: "20px" }}
          >
            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={() => {
                navigate("/");
              }}
            >
              Back
            </button>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default Dashboard;
